import BaseView from '../abstract-element-options';

module.exports = BaseView.extend({
  template: require('./template.hbs'),

  initialize: async function (options) {
    this.selection = options.selection;
    const { resources, folders } = await this.getSources(this.selection.type);
    this.sources = resources;
    this.folders = folders;

    BaseView.prototype.initialize.call(this, options);
  },

  getSources: async function (type) {
    if (type === 'logo') {
      return await this.getAllowedReplacements('Logo');
    }
    return await this.getAllowedReplacements('Icon');
  },

  fromFolderResourceToSource: function (resource) {
    if (typeof resource === 'string') {
      return {
        source: resource,
        thumbnail: resource
      };
    }
    return { source: resource.thumb_src, is_vector: resource.is_vector };
  },

  calculateColorGroups: function () {
    const selectedElement = document.querySelector(`#${this.selection.id}`);
    this.selection.shapes = INKIVE.DesignFacade.setters.sticker.updateMissingColorGroup(selectedElement, this.selection);

    return [...new Set(this.selection.shapes.map(shape => shape.fill.colorGroup).filter(Boolean))];
  },

  render: function () {
    const permissions = this.selection.permissions[0]?.basic || {};

    let type;
    if (this.selection.type === 'sticker') {
      type = 'vector';
    } else if (this.selection.type === 'shape') {
      type = 'vector';
    } else {
      type = this.selection.type;
    }

    const permissionName = `${type}_replace`;
    const globalPermissions = INKIVE.RestrictionsFacade.getAllDefaultPermissions();
    const canReplace = permissions[permissionName] ?? globalPermissions[permissionName];
    const hasColors = this.colors.length > 0;
    const colorGroups = this.calculateColorGroups();

    if ((canReplace && (this.sources || this.folders)) || hasColors) {
      this.$el.html(this.template({}));

      this.initReplacementPanel({
        folders: this.folders,
        assets: this.sources,
        colors: hasColors && colorGroups.map(colorGroup => ({ palette: [...this.colors], colorGroup }))
      }, type);
    } else if (canReplace && (type === 'logo' || type === 'icon' || this.selection.type === 'sticker')) {
      const showTab = type === 'logo' ? 'logo' : 'icon';
      this.$el.addClass('show-' + showTab + '-tab');
      this.$el.data('type', showTab);
    }
  },

  replaceItem: function (asset) {
    if (!asset.source) {
      return;
    }
    const selectedElement = INKIVE.DesignFacade.getSelectedElements()[0];
    const id = selectedElement.id;

    if (asset.action === 'color_replace') {
      const options = { fill: { color: asset.source, colorGroup: asset.details.colorGroup || '0' } };

      INKIVE.DesignFacade.set(id, options);
      return;
    }

    const url = asset.details.data.source || asset.source;
    const imageRatio = asset.details?.size.width / asset.details?.size.height || 1;

    if (selectedElement.classList.contains('sticker')) {
      selectedElement.classList.remove('sticker');
      selectedElement.classList.add('icon');
    }

    const selectedElementSize = selectedElement.getBBox();
    const width = selectedElementSize.width;
    const s3Source = asset.details?.data?.source;

    INKIVE.DesignFacade.set(id, {
      is_vector: url.endsWith('.svg'),
      smart_load: true,
      thumb_src: INKIVE.Helpers.getCORSSecureUrl(url),
      s3_source: s3Source,
      size: {
        width,
        height: width / imageRatio
      }
    });
  }

});
